<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data User" subTitle="Forms" />

    <ListUser />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import ListUser from "@/components/Pages/Master/User/ListUser.vue";

export default defineComponent({
  name: "ListUserPage",
  components: {
    PageTitle,
    ListUser,
  },
});
</script>
